import { getAuthHeaders, tempMeeApi } from '~/services/api';
import {
  ISubmitCancellationFeedbackApiRequest,
  ISubmitCancellationFeedbackApiResponse,
  ISubmitCancellationFeedbackPayload,
} from '../types';

export const submitCancellationFeedback = async (
  payload: ISubmitCancellationFeedbackPayload,
): Promise<ISubmitCancellationFeedbackApiResponse> => {
  const headers = await getAuthHeaders();
  const { jobId, cancellationFeedback, cancellationReason } = payload;

  const body: ISubmitCancellationFeedbackApiRequest = {
    cancellationFeedback,
    cancellationReason,
  };

  const response = await tempMeeApi.post<ISubmitCancellationFeedbackApiResponse>(
    `/jobs/${jobId}/cancellationFeedback`,
    body,
    { headers },
  );

  return response.data;
};
